<app-modal-base [title]="title" (onSubmitEvent)="onSubmit()" [loading]="isLoading" [isDisabled]="form.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <form [formGroup]="form">
      <div class="form-group row">
        <app-input *ngIf="isBookletRenovation" type="date" label="Date des travaux"
          [formControl]="form_installationDate"></app-input>
        <app-select label="Type d'isolant" [formControl]="form_typeCode" [list]="insulationTypeCodeList"
          [useLabelTranslation]="false" valueKey="code" displayKey="display" [isMultiple]="false"></app-select>
        <app-input label="Épaisseur" [formControl]="form_thickness" suffixText="mm"></app-input>
        @if (type === PropertyBookletInsulationType.windows) {

          <app-input label="Coefficient thermique" [formControl]="form_thermalCoefficient"
          suffixText="W/m².K"></app-input>
        } @else {
        <app-input label="Résistance thermique" [formControl]="form_thermalResistance"
          suffixText="m²K/W"></app-input>
        }
      </div>
      <div class="form-group row">
        @if (arePopulateData) {
        <div class="col-12 col-md-6">
          <app-doc-add-widget [prop]="data.prop" category="ENERGY" title="Fiche Produit *"
            (docSelected)="onProductSheetDocSelected($event)" (docDeleted)="onProductSheetDocDeleted()"
            [withSelect]="true" [withType]="false" [document]="form_productSheet.value">
          </app-doc-add-widget>
          <mat-error>
            <span *ngIf="form.touched && form_productSheet.hasError('required')">La fiche produit est
              obligatoire</span>
          </mat-error>
        </div>
        <div class="col-12 col-md-6">
          <app-doc-add-widget [prop]="data.prop" category="ENERGY" title="Détails de l'installation"
            (docSelected)="onInstallationDetailsDocSelected($event)" (docDeleted)="onInstallationDetailsDocDeleted()"
            [withSelect]="true" [withType]="false"
            [document]="form_installationDetails.value"></app-doc-add-widget>
        </div>
        }
      </div>
    </form>
  </div>
</ng-template>
